import { home } from './home.router'
import { dashboard } from './dashboard.router'
import { journal } from './journal.router'
import { attendance } from './attendance.router'
import { families } from './families.router'
import { familyDirectory } from './family-directory.router'
import { staff } from './staff.router'
import { communicate } from './communicate.router'
import { learn } from './learn.router'
import { finances } from './finances.router'
import { reports } from './reports.router'
import { setup } from './setup.router'
import { setupV2 } from './setup-v2.router'
import { superAdmin } from './super-admin.router'
import { superAdminV2 } from './super-admin-v2.router'
import { settings } from './settings.router'
import { developer } from './developer.router'

export const modules = [
  home,
  dashboard,
  attendance,
  families,
  familyDirectory,
  staff,
  journal,
  communicate,
  learn,
  finances,
  reports,
  setup,
  setupV2,
  superAdmin,
  superAdminV2,
  settings,
  developer,
]
